module.exports = new __parcel__URL__("light.86a15905.svg").toString();